import { Button, Modal, Typography } from '@p2p/components';
import { MSP_PDF_WARNING_SESSION_KEY } from '@p2p/shared/constants';
import { useScrollLock } from '@p2p/shared/hooks';
import { useState } from 'react';

import styles from './PdfWarningModal.module.scss';
import { PdfWarningModalProps } from './PdfWarningModal.types';

const isAcknowledged = (orderId: string) => {
  try {
    return sessionStorage.getItem(MSP_PDF_WARNING_SESSION_KEY) === orderId;
  } catch {
    return false;
  }
};

/**
 * P2P-2740: обязательное предупреждение о загрузке PDF-чека в MSP-флоу.
 * Показывается на экране с реквизитами (после выбора суммы) только клиентам,
 * у которых меньше 5 успешных депозитов по MSP (флаг show_pdf_warning с бэка).
 * Закрыть можно только кнопкой -- пока не подтвердил, платить нельзя.
 */
export const PdfWarningModal = ({ orderId, show }: PdfWarningModalProps) => {
  const [isAccepted, setIsAccepted] = useState(() => isAcknowledged(orderId));

  const isActive = show && !isAccepted;

  useScrollLock(isActive);

  const handleAccept = () => {
    try {
      sessionStorage.setItem(MSP_PDF_WARNING_SESSION_KEY, orderId);
    } catch {
      /* приватный режим / storage недоступен -- не критично */
    }

    setIsAccepted(true);
  };

  if (!isActive) return null;

  return (
    <Modal open onClose={handleAccept} className="pdf_warning">
      <Typography variant="h1" color="heading" className={styles.title}>
        Важно
      </Typography>

      <Typography variant="text-l-medium" color="description" className={styles.text}>
        Необходимо обязательно загрузить PDF-чек для успешного платежа, иначе средства будут
        потеряны.
      </Typography>

      <Button onClick={handleAccept}>Понятно</Button>
    </Modal>
  );
};
